import styled from "styled-components";

export const AtthyDuriLogo = styled.img`
  height: 40px;
`;
